import TopBanner from '../components/TicketDetails/TopBanner';
import { Grid } from '@mui/material';
import { useState, useEffect, useRef } from 'react';
import {
  Link,
  useParams,
  useSearchParams,
  useLocation,
  useNavigate
} from 'react-router-dom';
import Loader from '../components/Confirmations/Loader';
import TicketJourney from '../components/TicketDetails/TicketJourney';
import Comments from '../components/TicketDetails/Comments';
import Details from '../components/TicketDetails/Details';
import DetailsTabs from '../components/TicketDetails/DetailsTabs';
import { useTranslation } from 'react-i18next';
import SupportBar from '../components/SupportBar/SupportBar';
import { setCPSCtemForTicketJourney } from '../utils/cpscFormatting';
import { getSapKeyUser, getITSMDIncidentsDetails, getITSMDIncidents, getUniversalRequestDetails } from '../api/ticketsEndpoints';
import axiosInstance from '../utils/axiosInstance';
import TicketNotFoundPage from '../components/TicketDetails/TicketNotFound';
import { setSMTItemForTicketJourneyFromServiceNow, setUniversalRequestForTicketJourney } from '../utils/snFormatting';

const TicketJourneyPage = (props) => {
  const { t } = useTranslation();
  // Translations
  const alertNotAllowedToSeeSmtDetails = t(
    'ui_spear.sapKeyUser.You_are_only_authorized'
  );

  const { userInfo, isSupportEntitle } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const { ticketId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [source, setSource] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [isDataAvailable, setisDataAvailable] = useState(false);
  const [ticketNotFound, setTicketNotFound] = useState(false);
  const [showTicketJourney, setShowTicketJourney] = useState(true);
  const [originalLastDateTime, setOriginalLastSetTime] = useState('');
  const [originalSubmittedDate, setOriginalSubmittedDate] = useState('');
  const [rawTicketData, setRawTicketData] = useState('');
  const [smtTicketSummary, setSmtTicketSummary] = useState('');
  const [sapKeyUser, setSapKeyUser] = useState('');
  const [userBelongsTo, setUserBelongsTo] = useState();

  // ***** FIXED: Renamed state variable *****
  const [ticketDetails, setTicketDetails] = useState({
    activity_id: '',
    status: '',
    serviceName: '',
    serviceDescription: '',
    performer: '',
    performerFirst: '',
    performerLast: '',
    submittedDate: '',
    closedDate: '',
    taskDate: '',
    lastDateTime: '',
    cost: '',
    type: '',
    priority: '',
    onBehalf: '',
    requested_for: '',
    requisitionDueDate: '',
    sys_id: '',
    resolution: undefined,
    rejection_reason: '',
    requisition_id: '',
    performerLogin: '',
    of_Resolution: ''
  });

  useEffect(() => {
    // Only CPSC/Cisco tickets are supported here now (Cisco Archive).
    const langCode =
      props.userInfo && props.userInfo.userLanguage
        ? props.userInfo.userLanguage
        : 'en';
    const cpscEndpoint = `/api/v1/cpsc/tickets/details`;
    axiosInstance
      .get(`${cpscEndpoint}/${ticketId}?lang=${langCode}`)
      .then((res) => {
        if (res.data.data[0]) {
          let tempResponse = res.data.data;
          const orderById = res.data.data.find((order) => {
            return order.requisitionid === Number(ticketId);
          });
          tempResponse = setCPSCtemForTicketJourney(orderById);
          setSource('old');
          setTicketDetails(tempResponse);
          setisDataAvailable(true);
        } else {
          setisDataAvailable(true);
          setTicketNotFound(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setisDataAvailable(true);
        setTicketNotFound(true);
      });
  }, [location.pathname, ticketId, source, props?.userInfo]);

  const handleTabClick = (val) => {
    setShowTicketJourney(val);
  };

  // ===== LEGACY TICKET-SOURCE FLOWS (kept for reference) =====
  // These handled SMT/incident, Universal Request, and RITM tickets.
  // The active flow above now only serves CPSC/Cisco tickets (Cisco Archive),
  // so these are intentionally not called. Kept in case those sources return.
  // eslint-disable-next-line no-unused-vars
  const getItsmTicketDetailsAndValidateSapKeyUser = async () => {
    try {
      const userNtid = props?.userInfo?.userNTID;

      // If the userNTID hasn't arrived in the props yet, simply stop, only call the function if userNtid exists
      if (!userNtid) {
        return;
      }

      // Step 1: Check if the current user is an SAP Key User
      const sapKeyUserResponse = await getSapKeyUser(userNtid);
      const isSapKeyUser = !!sapKeyUserResponse?.data?.json;
      setSapKeyUser(isSapKeyUser);

      // Step 2: Fetch the ticket details
      // ... the rest of your function logic remains the same
      const detailsResponse = await getITSMDIncidentsDetails(ticketId);

      // Handle case where ticket is not found
      if (!detailsResponse || !detailsResponse.data || detailsResponse.data.length === 0) {
        setTicketNotFound(true);
        setisDataAvailable(true);
        return;
      }
      const ticketData = detailsResponse.data[0];

      // --- Step 3: Authorization Logic ---
      // Allow access if the user is: a SAP Key User, the caller (person ticket is for), or the opener (person who created it)
      const ticketCallerId = ticketData.caller_id?.user_name || '';
      const ticketOpenedById = ticketData.opened_by?.user_name || '';

      const isRegularUser = !isSapKeyUser;
      const isNotCaller = userNtid.toLowerCase() !== ticketCallerId.toLowerCase();
      const isNotOpener = userNtid.toLowerCase() !== ticketOpenedById.toLowerCase();

      if (isRegularUser && isNotCaller && isNotOpener) {
        alert(alertNotAllowedToSeeSmtDetails);
        return;
      }

      // --- Step 4: If we reach this point, the user is authorized ---
      const formattedTicket = setSMTItemForTicketJourneyFromServiceNow(ticketData);
      setSource('smt');
      setTicketDetails(formattedTicket);
      setRawTicketData(ticketData);
      setisDataAvailable(true);

    } catch (error) {
      console.log(
        'Error while verifying SAP KEY USER & Getting ticket details',
        error
      );
      setTicketNotFound(true); // Or show a generic error component
      setisDataAvailable(true);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const getUniversalRequestDetailsFlow = async () => {
    try {
      // 1. Wait for userInfo to populate before firing the API, just like Incidents do!
      const userNtid = props?.userInfo?.userNTID;
      if (!userNtid) {
        return; // Pause execution until React passes the user info down
      }

      const detailsResponse = await getUniversalRequestDetails(ticketId);

      if (!detailsResponse || !detailsResponse.data || detailsResponse.data.length === 0) {
        setTicketNotFound(true);
        setisDataAvailable(true);
        return;
      }

      const ticketData = detailsResponse.data[0];
      const formattedTicket = setUniversalRequestForTicketJourney(ticketData);
      setSource('ur');
      setTicketDetails(formattedTicket);
      setRawTicketData(ticketData);
      setisDataAvailable(true);
    } catch (error) { // 👇 FIX: Ignore aborted requests so they don't flash the error screen 👇
      console.error('Error fetching Universal Request details:', error);
      setTicketNotFound(true);
      setisDataAvailable(true);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const getRITMValidUser = async (ticket) => {
    try {
      let currentUser = await props?.userInfo?.userNTID;
      const snowEndpoint = `/api/v1/snow/tickets/details`;
      axiosInstance
        .get(`${snowEndpoint}/${ticketId}`)
        .then((res) => {
          setSource('new');
          const ticket = res.data.data[0].response[0];
          if (res.data.data[0].response[0] === undefined) {
            setTicketNotFound(true);
            setisDataAvailable(true);
            return;
          };
          if (ticket.requested_for_ntid.toLowerCase() !== currentUser.toLowerCase() && ticket.created_by_ntid.toLowerCase() !== currentUser.toLowerCase() && !userBelongsTo) {
            setShowAlert(true);
          } else {
            // ***** FIXED: Use the renamed state setter *****
            setTicketDetails({
              activity_id: ticket.activity_id,
              status: ticket.status,
              serviceName: ticket.serviceName,
              serviceDescription: ticket.serviceDescription,
              performer: ticket.performerFirst + ' ' + ticket.performerLast,
              performerFirst: ticket.performerFirst,
              performerLast: ticket.performerLast,
              submittedDate: ticket.submittedDate,
              closedDate: ticket.closedDate,
              taskDate: ticket.taskDate,
              lastDateTime: ticket.lastDateTime,
              cost: ticket.cost,
              type:
                ticket.serviceName === 'IT Support Request'
                  ? 'failure'
                  : 'request',
              priority: ticket.priority ? ticket.priority : 'low',
              onBehalf: ticket.onBehalf,
              requested_for: ticket.requested_for,
              requisitionDueDate: ticket.requisitionDueDate,
              sys_id: ticket.sys_id,
              rejection_reason: ticket.rejection_reason,
              requisition_id: ticket.requisition_id,
              performerDept: ticket.performerDept,
              performerLogin: ticket.performerLogin,
              comments: ticket.comments || [],
              of_Resolution: ticket.of_Resolution
            });
            setisDataAvailable(true);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      navigate('/error');
      console.log(
        'Error while verifiying USER & Getting ticket details',
        error
      );
    }
  }

  // eslint-disable-next-line no-unused-vars
  const getUserBelongsTo = async () => {
    try {
      let currentUser = await props?.userInfo?.userNTID;
      if (currentUser) {
        const userGroupsURL = `api/v1/snow/group/memberOf?user=${currentUser}`;
        axiosInstance
          .get(userGroupsURL)
          .then((res) => {
            setUserBelongsTo(res.data.data[0].responseValue);
          })
      }
    } catch (error) {
      navigate('/error');
      console.log(
        'Error while retrieving user groups',
        error
      );
    }
  }
  // ===== END LEGACY TICKET-SOURCE FLOWS =====

  if (showAlert) {
    alert(alertNotAllowedToSeeSmtDetails.replace('SMT', 'RITM'));
    navigate('/cisco/tickets');
  }

  return (
    <div className="pb-10 border-indigo-600">
      {!isDataAvailable ? (
        <Loader customStyle="inset-x-1/2 inset-y-1/2" />
      ) : ticketNotFound ? (
        <TicketNotFoundPage />
      ) : (
        <div>
          {/* ***** FIXED: Use the renamed state variable ***** */}
          <TopBanner
            ticketId={ticketDetails.activity_id}
            serviceName={ticketDetails.serviceName}
            status={ticketDetails.status}
          />
          <div className="flex justify-center">
            <div className="flex justify-center items-center w-4/6 border-b relative">
              <Link
                to="/cisco/tickets"
                className="ITSP_blue no-underline absolute left-0"
              >
                &lt; {t('ui_spear.ticketDetails.Back_to_Tickets')}
              </Link>
              <DetailsTabs
                showTicketJourney={showTicketJourney}
                handleTabClick={handleTabClick}
              />
            </div>
          </div>
          {showTicketJourney ? (
            <>
              {/* ***** FIXED: Use the renamed state variable ***** */}
              <TicketJourney
                TicketJourneyPage={ticketDetails}
                setOriginalLastSetTime={setOriginalLastSetTime}
                setOriginalSubmittedDate={setOriginalSubmittedDate}
                source={source}
              />
              <Comments
                userInfo={props.userInfo}
                TicketJourneyPage={ticketDetails}
                source={source}
                isSupportEntitle={isSupportEntitle}
                setSmtTicketSummary={setSmtTicketSummary}
              />
            </>
          ) : (
            <>
              {/* ***** FIXED: Use the renamed state variable ***** */}
              <Details
                SAPKeyUser={sapKeyUser}
                rawTicketData={rawTicketData}
                TicketJourneyPage={ticketDetails}
                source={source}
                originalLastDateTime={originalLastDateTime}
                originalSubmittedDate={originalSubmittedDate}
                smtTicketSummary={smtTicketSummary}
              />
              <Comments
                userInfo={props.userInfo}
                TicketJourneyPage={ticketDetails}
                source={source}
                isSupportEntitle={isSupportEntitle}
                setSmtTicketSummary={setSmtTicketSummary}
              />
            </>
          )}
          {isSupportEntitle && (
            <div className="py-10 w-4/6 mx-auto">
              <Grid item xs={9}>
                <div className="mb-12">
                  <h3 className="text-[1.75rem] mb-12 font-Bosch_sans_light">
                    {t('ui_spear.contactIT.Do_you_need_any_support')}
                  </h3>
                </div>
                {/* ***** FIXED: Use the renamed state variable ***** */}
                <SupportBar
                  userInfo={props.userInfo}
                  fromSupport={false}
                  serviceName={ticketDetails.serviceName}
                  ticketId={ticketDetails.activity_id}
                  sysId={ticketDetails.sys_id}
                  sowTable={
                    location.pathname.toLowerCase().includes('ticket-journey/inc')
                      ? 'incident'
                      : location.pathname
                        .toLowerCase()
                        .includes('ticket-journey/ur')
                        ? 'universal_request'
                        : location.pathname
                          .toLowerCase()
                          .includes('ticket-journey/r')
                          ? 'sc_req_item'
                          : ''
                  }
                />
              </Grid>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TicketJourneyPage;
